import Base from "../components/base/base";

class ModalItem {
	constructor(props = {}) {
		this.$root = props.$root;
		this.id = props.id;
		this.triggerList = props.triggerList;
		this.withCloseBtn = props.withCloseBtn || false;
		this.enabledScroll = props.enabledScroll || [];
		this.hash = props.hash || null;
		this.urlHashes = props.urlHashes || [];

		this.beforeOpen = props.beforeOpen || null;
		this.afterOpen = props.afterOpen || null;
		this.beforeClose = props.beforeClose || null;
		this.afterClose = props.afterClose || null;
		this.rootClass = props.rootClass || null;
		this.closeByButtonOnly = props.closeByButtonOnly || null;

		this.handleClick = this.handleClick.bind(this);
		this.handleOpen = null;
	}

	handleClick(e) {
		e.preventDefault();

		if (e.target.closest('.btn.-close')) return;

		let $trigger = e.target.closest('[data-modal-trigger]');
		$trigger = $trigger ? $trigger : e.currentTarget;

		const windowMobile = window.innerWidth <= 768;

		if (windowMobile && this.id === 'ny26') {
			setTimeout(() => {
				this.handleOpen(this.id, $trigger);
			}, 450);
		} else {
			this.handleOpen(this.id, $trigger);
		}
	}

	setTrigger(trigger) {
		if (!trigger) {
			throw new Error(`Modal Item / ${this.id}: Modal trigger is not defined.`);
		}

		if (
			(Array.isArray(trigger) && trigger.some((triggerItem) => !(triggerItem instanceof HTMLElement))) ||
			(!Array.isArray(trigger) && !(trigger instanceof HTMLElement))
		) {
			throw new TypeError('Modal Item / ${this.id}: Trigger must be a HTML Element.');
		}

		if (Array.isArray(trigger)) {
			this.triggerList = trigger;
		} else {
			this.triggerList.push(trigger);
		}

		this.addOpenListener(this.handleOpen);
	}

	addOpenListener(callback) {
		this.removeOpenListener();
		this.handleOpen = callback;

		this.triggerList.forEach(($trigger) => {
			$trigger.addEventListener('click', this.handleClick);
		});
	}

	removeOpenListener() {
		if (!this.handleOpen) return;

		this.triggerList.forEach(($trigger) => {
			$trigger.removeEventListener('click', this.handleClick);
		});
	}
}

export default class ModalService extends Base {
	constructor(props) {
		super(props);

		this.$modalRoot = document.getElementById('modal');
		this.$currentActive = this.$modalRoot.querySelector('.modal_item.-active');

		this.modalList = [];
		this.currentModal = null;
		this.isOpened = false;

		this.defaultClassList = this.$modalRoot.className;
		this.timeoutId = null;

		this.handleCloseByKeyUp = this.handleCloseByKeyUp.bind(this);
		this.open = this.open.bind(this);

		this.init();
	}

	addEventListeners() {
		this.$modalRoot.addEventListener('click', this.handleClose.bind(this));
		window.addEventListener('hashchange', () => {
			if (this.isOpened) return;

			for (const modalItem of this.modalList) {
				let matchedHash = null;

				if (
					modalItem.urlHashes &&
					Array.isArray(modalItem.urlHashes) &&
					modalItem.urlHashes.length
				) {
					modalItem.urlHashes.forEach((hash) => {
						if (typeof hash === 'string' && (new RegExp(`^${hash}`))
							.test(location.hash.slice(1))) {
							matchedHash = hash;
						}
					});
				} else if (
					modalItem.hash &&
					typeof modalItem.hash === 'string' &&
					(new RegExp(`^${modalItem.hash}`)).test(location.hash.slice(1))
				) {
					matchedHash = modalItem.hash;
				}

				if (matchedHash) {
					this.open(modalItem.id, null, { hash: matchedHash });
					break;
				}
			}
		});
	}

	register(modalId, trigger, options = {}) {
		const alreadyExists = this.getItem(modalId);
		const $root = document.getElementById(`modal-${modalId}`);

		if (alreadyExists) {
			throw new Error(`Modal Service / ${modalId}: Modal with such id has been already registered.`);
		}

		if (!$root) {
			throw new Error(`Modal Service / ${modalId}: Modal Element with id: "modal-${modalId}" does not exist.`);
		}

		if (options.rootClass && (typeof options.rootClass !== 'string' && !Array.isArray(options.rootClass))) {
			throw new TypeError('Modal Service: Class name must be a string or array of strings.');
		}

		const modalItem = new ModalItem({
			$root: $root,
			id: modalId,
			triggerList: [],
			hash: options.hash || null,
			urlHashes: options.urlHashes || [],
			beforeOpen: options.beforeOpen || null,
			afterOpen: options.afterOpen || null,
			beforeClose: options.beforeClose || null,
			afterClose: options.afterClose || null,
			rootClass: options.rootClass || null,
			withCloseBtn: options.withCloseBtn || false,
			closeByButtonOnly: options.closeByButtonOnly || false,
			enabledScroll: []
		});

		if (options.enabledScroll) {
			if (Array.isArray(options.enabledScroll)) {
				modalItem.enabledScroll = options.enabledScroll;
			} else {
				modalItem.enabledScroll.push(options.enabledScroll);
			}
		}


		if (trigger) {
			if (Array.isArray(trigger)) {
				modalItem.triggerList = trigger;
			} else {
				modalItem.triggerList.push(trigger);
			}

			modalItem.addOpenListener(this.open);
		}

		this.modalList.push(modalItem);

		let matchedHash = null;

		if (
			options.urlHashes &&
			Array.isArray(options.urlHashes)
		) {
			options.urlHashes.forEach((hash) => {
				if (typeof hash === 'string' && (new RegExp(`^${hash}`))
					.test(location.hash.slice(1))) {
					matchedHash = hash;
				}
			});
		} else if (
			options.hash &&
			typeof options.hash === 'string' &&
			(new RegExp(`^${options.hash}`)).test(location.hash.slice(1))
		) {
			matchedHash = options.hash;
		}

		if (matchedHash) {
			this.open(modalItem.id);
		}
	}

	changeTriggers(modalId, $triggers) {
		const modalItem = this.getItem(modalId);

		if (!modalItem || !modalItem.triggerList.length) {
			return;
		}

		modalItem.triggerList = $triggers;
		
		modalItem.addOpenListener(this.open);
	}

	getItem(id) {
		return this.modalList.find((item) => (item.id === id));
	}

	handleClose(e) {
		const $target = e.target;
		const $currentActive = this.$modalRoot.querySelector('.modal_item.-active');
		const ignoredBlockClassName = $currentActive.children[0].className.split(' ')[0];

		if (this.currentModal.closeByButtonOnly && !$target.closest('.modal-close, [data-modal="close"]') ||
			!this.currentModal.closeByButtonOnly && ($target.closest(`.${ignoredBlockClassName}`) && !$target.closest('.modal-close, [data-modal="close"]')) ||
			!document.body.classList.contains('-modal')
		) {
			return;
		}

		this.close();
	}

	handleCloseByKeyUp(e) {
		if (e.key !== 'Escape') return;
		this.close();
	}

	open(id, trigger = null, options = {}) {
		window.addEventListener('keyup', this.handleCloseByKeyUp);

		this.currentModal = this.getItem(id);

		if (!this.currentModal) {
			throw new Error('ModalService: Modal with such id is not registered.');
		}

		const hash = options.hash || this.currentModal.hash;
		const $currentActive = this.$modalRoot.querySelector('.modal_item.-active');

		if ($currentActive) {
			$currentActive.classList.remove('-active');
		}

		if (this.currentModal.rootClass) {
			if (Array.isArray(this.currentModal.rootClass)) {
				this.$modalRoot.classList.add(...this.currentModal.rootClass);
			} else {
				this.$modalRoot.classList.add(this.currentModal.rootClass);
			}
		}

		if (this.currentModal.withCloseBtn) {
			this.$modalRoot.classList.add('-with-btn');
		}

		this.currentModal.$root.classList.add('-active');
		scrollLock.disablePageScroll([this.$modalRoot, ...this.currentModal.enabledScroll]);

		if (this.currentModal.beforeOpen) {
			this.currentModal.beforeOpen(trigger, { hash });
		}

		if (hash) {
			location.hash = hash;
		}

		if (this.currentModal.closeByButtonOnly) {
			this.$modalRoot.classList.add('-close-by-button-only');
		}

		document.body.classList.add('-modal');

		if (this.currentModal.afterOpen) {
			setTimeout(() => {
				this.currentModal.afterOpen(trigger, { hash });
			}, 180);
		}

		this.isOpened = true;
	}

	close(callback) {
		if (!this.currentModal) {
			throw new Error('ModalService: No modals were open.');
		}

		window.removeEventListener('keyup', this.handleCloseByKeyUp);

		/* Remove hash */
		history.replaceState("", document.title, window.location.pathname + window.location.search);

		document.body.classList.remove(`-modal`);

		if (this.currentModal.beforeClose) {
			this.currentModal.beforeClose();
		}

		this.isOpened = false;


		setTimeout(() => {
			this.$modalRoot.classList.remove('-close-by-button-only');
			this.currentModal.$root.classList.remove('-active');

			scrollLock.clearQueueScrollLocks();
			scrollLock.enablePageScroll(this.$modalRoot);

			this.$modalRoot.classList.remove('-with-btn');

			if (this.currentModal.afterClose) {
				this.currentModal.afterClose();
			}

			this.$modalRoot.className = this.defaultClassList;

			if (callback) {
				callback();
			}
		}, 180);
	}
}